import { userInfoGetApi } from '@/api/common';
import { defineStore } from 'pinia';

export interface UserState {
    userData: {
        userId?: string;
        userName?: string;
        avatar?: string;
        gender?: string;
        phone?: string;
        tenantId?: string;
        tenantName?: string;
        tenantLogoUrl?: string;
        permissions?: any;
        shortName?: string;
    } | null;
}

// 用户信息全局状态
export const useUserStore = defineStore({
    id: 'user',
    state: (): UserState => ({
        userData: null
    }),
    getters: {
        getUser: (state) => state.userData
    },
    actions: {
        async initUser() {
            try {
                const { data } = await userInfoGetApi.send(true);
                this.userData = {
                    userId: data.sysUser.id,
                    userName: data.sysUser.username,
                    avatar: data.sysUser.avatar,
                    gender: '男',
                    phone: data.sysUser.phone,
                    tenantId: data.tenantId,
                    tenantName: data.tenantName,
                    tenantLogoUrl: data.logoImageUrl,
                    permissions: data.permissions,
                    shortName: data.shortName
                };
            } catch (error) {
                return error;
            }
        },
        updateUser(userData: Record<string, any>) {
            this.userData = { ...this.userData, ...userData };
        },
        deleteUser() {
            this.userData = null;
        }
    },
    persist: true
});
